import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GroupedUserDataV2 } from '@wilson/interfaces';
import { ShiftTimelineDataState } from '@wilson/shift-timeline/state';
import { of, Observable } from 'rxjs';

@Pipe({
  name: 'toUserDataV2',
})
export class ToUserDataV2Pipe implements PipeTransform {
  private store = inject(Store);

  transform(userId: string): Observable<GroupedUserDataV2[] | null> {
    if (userId) {
      return this.store.select(
        ShiftTimelineDataState.userTimelineRowDataStreamV2(userId),
      );
    } else {
      return of(null);
    }
  }
}
